export interface HoganConfig {
    cdn: string;
    amplitude: {
        api_key: string;
    };
    google_analytics: {
        id: string;
    };
    google_maps: {
        api_key: string;
    };
    google_places: {
        api_key: string;
    };
    meta_robots: string;
    csn: {
        search_service: {
            base_url: string;
            env: string;
        };
        venue_profile_service: {
            base_url: string;
            env: string;
        };
        rfp_service: {
            base_url: string;
            env: string;
        };
        gdpr_service: {
            base_url: string;
        };
    };
    sentry: {
        dsn: string;
    };
    ws_api_client: {
        base_url: string;
    };
    datadog: {
        applicationId: string;
        clientToken: string;
    };
}

// @ts-ignore
export const HOGAN_CONFIG: HoganConfig = process.env.HOGAN_CONFIG as HoganConfig;
export type HOGAN_CONFIG = typeof HOGAN_CONFIG;

export const IS_PROD_ENV = process.env.NODE_ENV === 'production';
export type IS_PROD_ENV = typeof IS_PROD_ENV;

export const IS_DEV_ENV = process.env.NODE_ENV === 'development';
export type IS_DEV_ENV = typeof IS_DEV_ENV;

export const IS_STAGING_ENV = process.env.IS_STAGING === '1';
export type IS_STAGING_ENV = typeof IS_STAGING_ENV;

export const IS_ALPHA_ENV = process.env.IS_ALPHA === '1';
export type IS_ALPHA_ENV = typeof IS_ALPHA_ENV;

// Whether or not the app is being run on client or nodejs server
export const IS_NODE_SERVER = !(typeof window !== 'undefined' && window.document);
export type IS_NODE_SERVER = typeof IS_NODE_SERVER;

export const IS_TEST_ENV = process.env.NODE_ENV === 'test';
export type IS_TEST_ENV = typeof IS_TEST_ENV;

export const APP_ROOT_DOM_NODE_ID = 'ws-react-app';
export type APP_ROOT_DOM_NODE_ID = typeof APP_ROOT_DOM_NODE_ID;

export const SERVER_ADDRESS = IS_DEV_ENV ? 'http://localhost:8000' : '';
export type SERVER_ADDRESS = typeof SERVER_ADDRESS;

export const AMPLITUDE_API_KEY = HOGAN_CONFIG.amplitude.api_key;
export type AMPLITUDE_API_KEY = typeof AMPLITUDE_API_KEY;

export const GA_TRACKING_ID = HOGAN_CONFIG.google_analytics.id;
export type GA_TRACKING_ID = typeof GA_TRACKING_ID;

export const GMAPS_API_KEY = HOGAN_CONFIG.google_maps.api_key;
export type GMAPS_API_KEY = typeof GMAPS_API_KEY;

export const GPLACES_API_KEY = HOGAN_CONFIG.google_places.api_key;

export const META_ROBOTS = HOGAN_CONFIG.meta_robots;

export const NODE_ENV = process.env.NODE_ENV || 'development';

// Still need for prod query param on profiles v2
export const CSN_VENUE_PROFILE_PROD_URL = 'https://www.cvent.com/api/venue-profile/v1/venue/fullProfiles?env=P2';

export const CSN_VENUE_PROFILE_URL = `${HOGAN_CONFIG.csn.venue_profile_service.base_url}venue-profile/v1/venue/fullProfiles?env=${HOGAN_CONFIG.csn.venue_profile_service.env}`;

export const SENTRY_DSN = HOGAN_CONFIG.sentry.dsn;

export const TYPEAHEAD_DATA_TTL = 1000 * 60 * 60 * 2;
